import React, { useRef, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import "./popupsright.css";
import firecorrect from "../images/firecorrect.png";

const FlameButtonWithDropdown = () => {
  const btnRef = useRef(null);
  const popupRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // detect mobile / desktop
  useEffect(() => {
    const resize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  // inchide popup la click in afara
  useEffect(() => {
    const close = (e) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(e.target) &&
        !btnRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  useEffect(() => {
    if (open) {
      document.body.classList.add("stats-popup-open");
    } else {
      document.body.classList.remove("stats-popup-open");
    }

    return () => {
      document.body.classList.remove("stats-popup-open");
    };
  }, [open]);

  return (
    <div className="first-main-pagi-flame-wrapper">
      {/* BUTON */}
      <div
        ref={btnRef}
        className="first-main-pagi-stats-button"
        onClick={() => setOpen(!open)}
      >
        <img
          src={firecorrect}
          alt="flame"
          className="first-main-pagi-stats-icon"
        />
        <div className="first-main-pagi-stats-number">0</div>
      </div>

      {open && createPortal(
        <>
          <div
            className="first-main-pagi-overlay"
            onClick={() => setOpen(false)}
          />

          <div
            ref={popupRef}
            className={`first-main-pagi-popup first-main-pagi-flame-popup ${
              isMobile ? "mobile" : "desktop"
            }`}
          >
            <div className="streak-popup-header">
              <div className="streak-title">0 zile consecutive</div>
              <div className="streak-subtitle">Finalizeaza o lectie azi pentru a incepe un nou streak!</div>
              <div className="streak-flame-icon">
                <span role="img" aria-label="flame" style={{fontSize: '2rem'}}><img
          src={firecorrect}
          alt="flame"
          className="first-main-pagi-stats-icon"
        /></span>
              </div>
            </div>

            <div className="streak-days-row">
              <span className="streak-day active">L</span>
              <span className="streak-day">M</span>
              <span className="streak-day">M</span>
              <span className="streak-day">J</span>
              <span className="streak-day">V</span>
              <span className="streak-day">S</span>
              <span className="streak-day star">★</span>
            </div>

            <div className="streak-club-box">
              <div className="streak-club-lock">
                <span role="img" aria-label="lock" style={{fontSize: '1.5rem', marginRight: 8}}></span>
                <span className="streak-club-title">Mentine seria</span>
              </div>
              <div className="streak-club-desc">Finalizeaza 7 zile consecutive de studiu pentru a-ti mentine seria.</div>
              <div className="streak-progress-bar">
                <div className="streak-progress" style={{width: '10%'}}></div>
                <span className="streak-progress-flame" style={{left: '10%'}}>
                  <span role="img" aria-label="flame"><img
          src={firecorrect}
          alt="flame"
          className="first-main-pagi-stats-icon"
        /></span>
                </span>
              </div>
            </div>

            <button className="streak-view-more-btn"><span className="color-button-streak">Vezi progresul</span></button>
          </div>
        </>,
        document.body
      )}
    </div>
  );
};

export default FlameButtonWithDropdown;
